import { GetFieldDefBy } from "./GetFieldDefBy";

export function GetNameDefForClass(aClass) {
  var nameIDDef = aClass.GetFieldDefByID("Name");
  if (nameIDDef == null) nameIDDef = aClass.GetFieldDefByID("PersonID");

  return nameIDDef;
}
